var idCounter = 0;
function id() {
    return idCounter++;
}
export { id };
//# sourceMappingURL=id.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/inversify/es/utils/id.js
// module id = 210
// module chunks = 0